import { autofill } from './autofill'

export const CONSOLIDATION_ADVISORY_TITLE = 'Space-saving tip'

const area = size => size.width_in * size.height_in

// A candidate fits iff the packer places every item on ONE sheet: autofill
// never throws on overflow — it reports overflow via `unplaceable`.
const fitsOneSheet = (items, size) => autofill(items, size, 1).unplaceable.length === 0

export function buildConsolidationAdvisory({
  items,
  sheetSizes,
  currentSheetSizeId,
  contentSheetCount,
  integrationMode,
}) {
  if (!Array.isArray(items) || items.length === 0) return null
  if (!Number.isInteger(contentSheetCount) || contentSheetCount < 2) return null

  const catalog = sheetSizes || []
  const current = catalog.find(size => Number(size.id) === Number(currentSheetSizeId))
  if (!current) return null

  const candidates = catalog.filter(size => (
    Number(size.id) !== Number(current.id) &&
    size.width_in >= current.width_in &&
    size.height_in >= current.height_in &&
    area(size) > area(current) &&
    (integrationMode !== 'variant_mode' || size.has_shopify_variant === true) &&
    fitsOneSheet(items, size)
  ))
  if (candidates.length === 0) return null

  const byArea = (a, b) => area(a) - area(b)
  const pricedPath = integrationMode === 'variant_mode' &&
    Number.isInteger(current.price_cents) &&
    candidates.some(size => Number.isInteger(size.price_cents))

  if (!pricedPath) {
    return { winner: [...candidates].sort(byArea)[0], sheetCount: contentSheetCount, deltaCents: null }
  }

  const pricedCandidates = candidates.filter(size => Number.isInteger(size.price_cents))
  const winner = [...pricedCandidates]
    .sort((a, b) => (a.price_cents - b.price_cents) || byArea(a, b))[0]
  const deltaCents = contentSheetCount * current.price_cents - winner.price_cents

  if (deltaCents < 0) return null
  return {
    winner,
    sheetCount: contentSheetCount,
    deltaCents: deltaCents > 0 ? deltaCents : null,
  }
}

export function consolidationAdvisoryCopy(advisory) {
  if (!advisory) return null
  const savings = advisory.deltaCents
    ? `, saving about $${(advisory.deltaCents / 100).toFixed(2)}`
    : ''
  return `Your artwork would fit on one ${advisory.winner.label} sheet${savings}. Switching re-arranges your artwork automatically.`
}
